// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2KalZ","savePackageButton":"ClientWallet_savePackageButton__1ws73"};